import { useRBAC } from '@crehana/rbac/hooks/use-rbac';
import { TargetSegmentEnum } from "../../shared";

/**
 * Hook que valida y ajusta el rol del usuario según sus permisos.
 *
 * Si el role es "end-user" y el usuario es líder, retorna "leader".
 * Si el role es "end-user" y el usuario no es líder, retorna "end-user".
 * Si el role es "admin" o cualquier otro valor, lo retorna sin cambios.
 *
 * @param role - El rol original a validar
 * @returns El rol validado según los permisos del usuario
 */
export var useValidatedTargetSegment = function useValidatedTargetSegment(role) {
  var _useRBAC = useRBAC(),
    isLeader = _useRBAC.isLeader;
  return role === TargetSegmentEnum.EndUser && isLeader() ? TargetSegmentEnum.Leader : role;
};